<freud-dialog
	[header]="'RECURRENCY_ATTEMPT.CANCEL_INVITE' | translate"
	[visible]="isOpen"
	(visibleChange)="!$event && onClose.emit()"
>
	<div>
		<div class="zk-flex zk-flex-col">
			<freud-radio-button
				[(ngModel)]="removeRange"
				[label]="'RECURRENCY_ATTEMPT.CANCEL_THIS' | translate"
				[name]="'removeRange'"
				[radioValue]="'current'"
			></freud-radio-button>
			<freud-radio-button
				[(ngModel)]="removeRange"
				[label]="'RECURRENCY_ATTEMPT.CANCEL_ALL_NOT_CONFIRMED' | translate"
				[name]="'removeRange'"
				[radioValue]="'all'"
			></freud-radio-button>
		</div>
	</div>
	<div freudTemplatefooter>
		<freud-button
			[disabled]="isLoading"
			color="secondary"
			(click)="onClose.emit()"
			(keyup)="$event.key === 'Enter' ? onClose.emit() : null"
			>{{ 'OPERATIONS.CLOSE' | translate }}</freud-button
		>
		<freud-button
			[loading]="isLoading"
			(click)="cancelInvites()"
			(keyup)="$event.key === 'Enter' ? cancelInvites() : null"
			>{{ 'OPERATIONS.CONFIRM' | translate }}</freud-button
		>
	</div>
</freud-dialog>
